<template>
  <div id="question-template">
    <h3 class="headline">
      {{ question }}
    </h3>

    <!-- Checkbox -->
    <div
      v-if="type==='checkbox'"
      class="my-10">
      <div
        v-for="(answer, index) in answers"
        :id="answer+index"
        :key="answer+index"
        class="my-3">
        <v-row
          align="center"
          :class="selected.includes(answer) ? 'grey darken-1 white--text elevation-4' : 'grey lighten-2'"
          style="border-radius: 8px; border: 0.5px solid black;">
          <input
            :id="answer"
            v-model="selected"
            type="checkbox"
            class="d-none"
            :value="answer"
            @click="onUpdate($event)">
          <label
            :for="answer"
            class="px-3 py-1"
            style="flex: 1;">
            {{ answer }}
          </label>
        </v-row>
      </div>
    </div>
    <!-- End Checkbox -->

    <!-- Radio -->
    <div
      v-if="type === 'radio'"
      class="my-10">
      <div v-for="(answer, index) in answers"
           :id="order"
           :key="index">
        <v-row
          align="center"
          :class="selected.includes(answer) ? 'grey darken-1 white--text elevation-4' : 'grey lighten-2'"
          style="border-radius: 8px; border: 0.5px solid black;"
          class="my-3">
          <input
            :id="answer"
            v-model="selected"
            type="radio"
            class="d-none"
            :value="answer"
            @click="onUpdate($event)">
          <label
            :for="answer"
            class="px-3 py-1"
            style="flex: 1;">
            {{ answer }}
          </label>
        </v-row>
      </div>
      <br>
    </div>
    <!-- End Radio -->

    <!-- For text field, email and telephone number -->
    <!-- Textfield -->
    <div
      v-if="type === 'text' || type === 'email' || type === 'tel'"
      class="my-5">
      <v-text-field
        :label="placeholder"
        :value="selected"
        :rules="[rules.required, rules.email]"
        @input="onUpdate($event)" />
    </div>
    <!-- End Textfield -->
  </div>
</template>
<script>
/**
 * Props:
 *  question: String,
 *  answers: Array,
 *  type: String -> ['checkbox', 'radio', 'text', 'email', 'tel'], (HTML input types)
 *  order: Number,
 *  prevselected: Array
 * State:
 *  selected: Array
 * */
import Vue from 'vue';

export default {
	name: 'QuestionTemplate',

	props: {
		question: {
			type: String,
			required: true
		},

		answers: {
			type: Array,
			default: () => {}
		},

		type: {
			type: String,
			required:true
		},

		order: {
			type: Number,
			required: true
		},

		prevselected: {
			type: Array,
			required: true
		},

		placeholder: {
			type: String,
			required: false,
			default: 'Please fill in here.'
		}
	},

	data: function() {
		return {
			valid: false,

			// Set previous selected
			selected: [],

			// Regular Expression
			rules: {
				required: value => !!value || 'Required.',
				email: value => {
					let errorMessage = '';
					let pattern = '';

					if (this.type === 'email') {
						pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
						errorMessage = 'Invalid e-mail.';
					}

					if (this.type === 'tel') {
						// pattern = /^[\d]{3}[\-]{1}[\d]{8,}$/;
						pattern = /^[\d]{8,}$/;
						errorMessage = 'Invalid phone number.';
					}

					if (this.type === 'text') {
						pattern = /^[A-Za-z\s]*$/;
						errorMessage = 'Invalid input.';
					}

					this.valid = pattern.test(value);
					return pattern.test(value) || errorMessage;
				},
			}
		};
	},

	computed: {

		// beautifySelected: function() {

		// 	// telephone number +000-12345678...
		// 	if (this.type === 'tel'
		// 		&& this.selected !== undefined
		// 		&& this.selected.length === 1
		// 		&& this.selected[0].length > 3
		// 		&& !this.selected[0].includes('-')) {
		// 		return this.selected[0].slice(0, 3) + '-' + this.selected[0].slice(3);
		// 	};

		// 	return this.selected;
		// }

	},

	mounted: function() {
		// Check prevselected for relevant 'Order' and set to selected.
		let found = this.prevselected.find(selected => selected['Order'] === this.order);
		if (found !== undefined) this.selected = found['Answer'];
	},

	methods: {

		onUpdate(event) {
			// TODO: Not quite right.
			// Only for textfield input
			if (this.type === 'text'
				|| this.type === 'tel'
				|| this.type === 'email') {
				this.selected = event !== "" ? [ event ] : [];
			}

			if (this.type === 'radio'
				|| this.type === 'checkbox') {
				this.valid = true;
			}

			setTimeout(() => {
				this.$emit('save-enquiry', {
					'Valid': this.valid,
					'Question': this.question,
					'Answer': this.selected,
					'Order': this.order,
					'Type': this.type
				});
			}, 200);
		}
	}
};
</script>

<style>

</style>